import React, { 
    useState,
    useEffect
} from 'react'
  
import Navbar from '../../Components/Navbar/Navbar'
import toast from 'react-hot-toast';
import { validateExpenseArrayObjects } from '../../Components/Validations/ArrayObjectValidation';
import { SeeAttachment } from '../../Components/SeeAttachment';
import dayjs from 'dayjs';

import { 
    Layout,
    Table,
    Col, 
    Row,
    Button,
    Upload,
    Divider,
    Form,
    Select,
    Input,
    DatePicker,
    Radio,
    InputNumber,
    Space,
} from 'antd'

import { 
    InboxOutlined,
    DeleteOutlined,
    ProductOutlined,
} from '@ant-design/icons';

import { formatAmount, validateSpaces } from '../../Utils/Common';
import { useNavigate, useParams } from 'react-router-dom';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'

const { Item } = Form;
const { Option } = Select;
const { TextArea } = Input;
const AddEditExpense = () => {
    const [addExpenseForm] = Form.useForm();
    const { form, label, id } = useParams();
  
    const expense_form = {
        unit: {
            path: '/expense',
            navkey: '/expenses_nav',
            create: 'expenses/create',
            update: 'expenses/update',
            tenant_get: 'tenants/get',
            owner_get: 'owners/get',
            get: 'expenses/get',
            header: 'ADD EXPENSE',
            header1: 'EDIT EXPENSE',
            header2: 'VIEW EXPENSE',
        },
        parking: {
            path: '/parking-expense',
            navkey: '/parking_expenses_nav',
            create: 'parking_expenses/create',
            update: 'parking_expenses/update',
            tenant_get: 'tenant_parkings/get',
            owner_get: 'owners/get_with_parking_unit',
            get: 'parking_expenses/get',
            header: 'ADD PARKING EXPENSE',
            header1: 'EDIT PARKING EXPENSE',
            header3: 'VIEW PARKING EXPENSE',
        }
    };
  
    const { callPost, loading } = usePostRequest(()=>{
      addExpenseForm.resetFields();
      navigate(expense_form[form].path)
    });

    const customSpinner = <ProductOutlined style={{ fontSize: 24 }} spin />;

    const navigate = useNavigate()
    const [isDisabled, setIsDisabled] = useState(true);
    const [unitId, setUnitId] = useState('');
    const [type, setType] = useState('tenant');
    const [paymentMethod, setPaymentMethod] = useState('cash');
    const [ownerData, setOwnerData] = useState([]);
    const [tenantData, setTenantData] = useState([]);
    const [supplierData, setSupplierData] = useState([]);
    const [rentalUnitData, setRentalUnitData] = useState([]);
    const [parkingUnitData, setParkingUnitData] = useState([]);
    const [attachmentsData, setAttachmentsData] = useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const [newAttachment, setNewAttachment] = useState([]);
    const [paymentStatus, setPaymentStatus] = useState(false);

    const [dataSource, setDataSource] = useState([
        {
            item: '',
            amount: '',
        },
        {
            item: '',
            amount: '',
        },
    ]);
  
    const type_select = [
        ...(form === 'unit' ? [
        {
            id: '1',
            value: 'internal',
            name: 'Internal',
        }
        ] : []),
        {
            id: '2',
            value: 'tenant',
            name: 'Tenant',
        },
        {
            id: '1',
            value: 'owner',
            name: 'Owner',
        },
    ];  

    const columns2 = [
        {
          title: 'Date Added',
          dataIndex: 'added_on',
          key: 'added_on',
          width: '30%',
          render: (amount) => formatAmount(amount),
        },
        {
          title: 'Attachments',
          dataIndex: 'link',
          key: 'link',
        },
    ];  

    const values = Form.useWatch([], addExpenseForm);

    React.useEffect(() => {
        addExpenseForm.validateFields({
        validateOnly: true,
        }).then(() => {
            setIsDisabled(false);
        },
        () => {
            setIsDisabled(true);
        },
        );
    }, [values, addExpenseForm]);

    const handleInputChange = (e, fieldName, recordKey) => {
        const updatedDataSource = dataSource.map((item, index) => {
            if (index === recordKey) {
                if(fieldName === "amount"){
                return { ...item, [fieldName]: e };
                } else {
                return { ...item, [fieldName]: e.target.value };
                }
            }
            return item;
        });

        setDataSource(updatedDataSource);
    };
  
    const handleAddRow = () => {
        const newRow = {
            item: "",
            amount: "",
        };

        setDataSource(prev => [...prev, newRow]);
    };
  
    const handleDeleteRow = (rowId) => {
        const newData = [...dataSource];
        newData.splice(rowId, 1); 
        setDataSource(() => newData)
    };
  
    const grandTotal = dataSource.reduce((total, item) => {
        return total + parseFloat(item.amount || 0);
    }, 0);
 
    const columns = [
        {
            title: 'Items',
            dataIndex: 'item',
            render: (_, record, index) => (
                <Input
                    disabled={paymentStatus}
                    value={record.item}
                    onChange={(e) => handleInputChange(e, 'item', index)}
                />
            ),
        },
        {
            title: 'Amounts',
            dataIndex: 'amount',
            render: (_, record, index) => (
                <InputNumber
                    disabled={paymentStatus}
                    style={{width:'100%'}}
                    value={record.amount}
                    onChange={(e) => handleInputChange(e, 'amount', index)}
                />
            ),
        },
        {
            title: 'Action',
            dataIndex: 'action',
            align: 'center',
            render: (_,record, index) => (
                <div className='center'>
                    <Button
                        disabled={paymentStatus}
                        icon={<DeleteOutlined />}
                        onClick={() => handleDeleteRow(index)}
                        type="link"
                        size='large'
                        danger
                    />
                </div>
            ),
        },
    ];
  
    const options = [
        {
            label: 'Cash',
            value: 'cash',
        },
        {
            label: 'Check',
            value: 'check',
        },
        {
            label: 'Other',
            value: 'others',
        },
    ];
  
    async function fetchTenantData() {
        const response = await UseGetRequest(expense_form[form].tenant_get, {tenant_id: '', for_expense: 1});
        if (response.data) {
            setTenantData(response.data.data);
        } else {
            setTenantData([])
        }
    }
  
    async function fetchOwnerData() {
        const response = await UseGetRequest(expense_form[form].owner_get, {owner_id: ''});
        if (response.data) {
            setOwnerData(response.data.data);
        } else {
            setOwnerData([])
        }
    }
  
    async function fetchParkingUnitData(parking_id, parking_type) {
        let requestData = parking_type === 'tenant' 
        ? { tenant_parking_id: parking_id } 
        : { owner_id: parking_id };
        const response = await UseGetRequest("parking_units/get", requestData);

        if (response.data) {
            setParkingUnitData(response.data.data);
        } else {
            setParkingUnitData([]);
        }
    }
  
  
    async function fetchRentalUnitOwner(ownerId) {
        const response = await UseGetRequest("rental_units/get", {owner_id: ownerId});
        if (response?.data) {
            setRentalUnitData(response?.data?.data);
        } else {
            setRentalUnitData([])
        }
    }
  
    async function fetchSupplierData() {
        const response = await UseGetRequest("suppliers/get", {supplier_id: ''});
        if (response.data) {
            setSupplierData(response.data.data);
        } else {
            setSupplierData([])
        }
    }
  
  
    const handleAddExpense = () => {
        addExpenseForm.validateFields().then(values => {
            const resetData = {
            supplier_id: values?.supplier_id || "",
            main_usage: values?.main_usage || "",
            sub_usage: values?.sub_usage || "",
            description: values?.description || "",
            remarks: values?.remarks || "",
            total: grandTotal || "",
            payment_type: paymentMethod || "",
            paid_amount: values?.paid_amount || "",
            payment_remarks: values?.payment_remarks || "",
            check_no: values?.check_no || "",
            bank: values?.bank || "",
            other_type: values?.other_type || "",
            reference_no: values?.reference_no || "",

            ...(form === "parking"
                ? {
                    tenant_parking_id: values?.tenant_id || "",
                    owner_id: values?.owner_id || "",
                    parking_unit_id: values?.parking_unit_id || "",
                    }
                : {
                    tenant_id: values?.tenant_id || "",
                    owner_id: values?.owner_id || "",
                    rental_unit_id: type === "tenant" 
                        ? unitId || "" 
                        : values?.rental_unit_id || "",
                    }),
            };
        
    
            resetData.expense_date = values?.expense_date ? values.expense_date.format("YYYY-MM-DD") : "";
            resetData.date_covered = values?.date_covered ? values.date_covered.format("YYYY-MM-DD") : "";
            resetData.payment_date = values?.payment_date ? values.payment_date.format("YYYY-MM-DD") : "";
            resetData.check_date = values?.check_date ? values.check_date.format("YYYY-MM-DD") : "";
            
            resetData.items = dataSource.map((item)=>item.item)
            resetData.amounts = dataSource.map((item)=>item.amount)
    
            const file = attachmentsData.map((file) => {
                return file.originFileObj;
            });
            
            var finalValues = Object.entries({...resetData, attachments: file}).map(([key, value]) => ({
                key,
                value,
            }));
    
    
            callPost(
                expense_form[form].create, 
                finalValues,
                true,
            );
        }).catch(errorInfo => {
            toast.error('Validation Failed:', errorInfo);
        });
    };
      
    const handleEditExpense = () => {
        addExpenseForm.validateFields().then(values => {
            const resetData = {
                supplier_id: values?.supplier_id || "",
                main_usage: values?.main_usage || "",
                sub_usage: values?.sub_usage || "",
                description: values?.description || "",
                remarks: values?.remarks || "",
                total: grandTotal || "",
                
                payment_type: paymentMethod || "",
                paid_amount: values?.paid_amount || "",
                payment_remarks: values?.payment_remarks || "",

                check_no: values?.check_no || "",
                bank: values?.bank || "",

                other_type: values?.other_type || "",
                reference_no: values?.reference_no || "",
                ...(form === "parking"
                    ? {
                        parking_expense_id: id,
                        tenant_parking_id: values?.tenant_id || "",
                        owner_id: values?.owner_id || "",
                        parking_unit_id: values?.parking_unit_id || "",
                    }
                    : {
                        expense_id: id,
                        tenant_id: values?.tenant_id || "",
                        owner_id: values?.owner_id || "",
                        rental_unit_id: type === "tenant" 
                            ? unitId || "" 
                            : values?.rental_unit_id || "",
                    }),
            };

            resetData.expense_date = values?.expense_date ? values.expense_date.format("YYYY-MM-DD") : "";
            resetData.date_covered = values?.date_covered ? values.date_covered.format("YYYY-MM-DD") : "";
            resetData.payment_date = values?.payment_date ? values.payment_date.format("YYYY-MM-DD") : "";
            resetData.check_date = values?.check_date ? values.check_date.format("YYYY-MM-DD") : "";
            
            resetData.items = dataSource.map((item)=>item.item)
            resetData.item_ids = dataSource.map((item)=>item.id || "")
            resetData.amounts = dataSource.map((item)=>item.amount)
    
            const file = attachmentsData
            .filter(data => data.originFileObj)
            .map(data => data.originFileObj);
            
            const attch_ids = attachmentsData
            .filter(data => data.id)
            .map(data => data.id);
            
            var finalValues = Object.entries({...resetData, attachments: file, attachment_ids: attch_ids}).map(([key, value]) => ({
                key,
                value,
            }));
    
    
            callPost(
                expense_form[form].update, 
                finalValues,
                true,
            );
        }).catch(errorInfo => {
          toast.error('Validation Failed:', errorInfo);
        });
    };

    async function fetchExpenseData() {
        setIsLoading(true)
        const response = await UseGetRequest(expense_form[form].get, {expense_id: id});
    
        if (response?.data) {
          const data = response?.data?.data[0]
          addExpenseForm.setFieldsValue({
            supplier_id: data?.supplier_id || "",
            ...(data.type === "owner" && 
                {   
                    owner_id: data?.owner_id || "",
                    rental_unit_id: data?.rental_unit_id || ""
                }),
            ...(data.type === "tenant" && 
                {   
                    tenant_id: form === 'unit' ? data?.tenant_id || "" : data?.tenant_parking_id || "",
                }),
            description: data?.description || "",
            expense_date: dayjs(data.expense_date) || "",
            date_covered: data.date_covered ? dayjs(data.date_covered) : "",
            main_usage: data?.main_usage || "",
            sub_usage: data?.sub_usage || "",
            remarks: data?.remarks || "",
            type: data.type,
    
            paid_amount: data?.paid_amount || "",
            payment_date: dayjs(data?.payments?.payment_date),
            payment_remarks: data?.payments?.payment_remarks || "",
    
            check_no: data?.payments?.check_no || "",
            check_date: dayjs(data?.payments?.check_date),
            bank: data?.payments?.bank || "",
        
            other_type: data?.payments?.other_type || "",
            reference_no: data?.payments?.reference_no || "",
            ...(form === "parking"
              && 
                {
                  parking_unit_id: data?.parking_unit_id || "",
                }
              ),
          });
          let attachment = data?.attachments?.map((file) => ({
            ...file,
            link: (
              <SeeAttachment
                attachments={[
                  { file_url: file.file_url, file_name: file.file_name },
                ]}
              />
            ),
          })) 
    
          let item_data = data?.items?.map((data) => ({
            ...data,
            item: data.item,
            amount: data.amount,
          })) 
    
          setNewAttachment(attachment)
          setAttachmentsData(fileUrlFormat(data?.attachments))
          setUnitId(data?.rental_unit_id )
          setType(data.type);
          setDataSource(item_data)
          setPaymentMethod(data?.payments?.payment_type)
          setPaymentStatus(data?.status === "completed" ? true : false)
          if(data.type === "owner"){
            fetchRentalUnitOwner(data?.owner_id, data?.rental_unit_id)
          }
          if(form === "parking"){
            fetchParkingUnitData(
              data.type === 'tenant' ? data?.tenant_parking_id  : data?.owner_id, 
              data.type === 'tenant' ? 'tenant' : 'owner'
            )
          }
          // setPaymentMethod(data?.p)
        } else {
          addExpenseForm.resetFields();
        }
        setIsLoading(false);
      }
        const fileUrlFormat = (files) => {
            if(files){
            return files?.map(file => ({
                uid: file.id,
                id: file.id,
                name: file.file_name,
                status: "done",
                url: file.file_url,
                fileType: file.file_type
            }));
        }
    };
  
    const onMethodChange = ({ target: { value } }) => {
        setPaymentMethod(value);
    };
  
    const handleDeleteAttachment = (file) => {
        const updatedAttachments = attachmentsData.filter(item => item !== file);
        setAttachmentsData(updatedAttachments);
    };
  
  
    const normFile = (e) => {
  
        if (Array.isArray(e)) {
            setAttachmentsData(e)
        }
        setAttachmentsData(e?.fileList)
      
    };
  
    const handleType = (value) => {
        setType(value)
        addExpenseForm.resetFields(['bank','check_date','check_no', 'other_type', 'reference_no','parking_unit_id']);
    };  

    const handleSaveExpense = () => {
        if(label === 'add'){
            handleAddExpense();
        } else {
            handleEditExpense();
        }
    };  
  
    const handleUnits = (rental_id, type) => {
        if(form === 'parking'){
            if(type === "owner"){
                fetchParkingUnitData(rental_id, 'owner')
            } else if (type === "tenant"){
                fetchParkingUnitData(rental_id, 'tenant')
            } else {
                setParkingUnitData()
            }
        } else if(form === 'unit'){
            if(type === "owner"){
                fetchRentalUnitOwner(rental_id)
            } else if (type === "tenant"){
                var renter = tenantData.filter(item => item.id === rental_id)
                setUnitId(renter[0]?.rental_unit_id)
            } else {
                setRentalUnitData([])
            }
        }
    }
  
    useEffect(() => {
        switch (type) {
            case "tenant":
                fetchTenantData();
                break;
            case "owner":
                fetchOwnerData();
                break;
            default:
                break;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type]);
  
    useEffect(() => {
        fetchSupplierData();
    }, []);

    useEffect(() => {
        if(id && label === 'edit'){
          fetchExpenseData();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);
  
    useEffect(() => {
        addExpenseForm.setFieldsValue({
            paid_amount: grandTotal
        });
    }, [grandTotal, addExpenseForm]);
  
    return (
        <Layout className='page'>
            <Navbar navKey={expense_form[form].navkey}/>
            <Layout className='content-container overflow-y'>
                <Row>
                    <Col span={24} className='header-container p-3'>
                        {label === 'add' ? expense_form[form].header : paymentStatus ? expense_form[form].header2 : expense_form[form].header1}
                    </Col>
                </Row>
                <Row>
                    <Col span={24} className='p-3'>
                        <Form  
                            form={addExpenseForm} 
                            layout="vertical"
                            initialValues={{type : 'tenant'}}
                        >
                            <Divider className='divider-text'>Unit Information</Divider>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={8} className='p-2'>
                                    <Item
                                        label="Supplier Tradename"
                                        name="supplier_id"
                                        rules={[{ required: true, message: 'Please select your Supplier' }]} // Adjusted message
                                    >
                                        <Select disabled={paymentStatus} placeholder="Select a supplier">
                                            {supplierData.map((option, index) => (
                                            <Option key={index} value={option.id}>{option.tradename}</Option>
                                            ))}
                                        </Select>
                                    </Item>
                                </Col>
                                <Col span={8} className='p-2'>
                                    <Item
                                        label="Expense Date"
                                        name="expense_date"
                                        // className="mt-2"
                                        rules={[{ required: true, message: 'Please select a Expense Date' }]}
                                    >
                                        <DatePicker disabled={paymentStatus} style={{ width: '100%' }} />
                                    </Item>
                                </Col>
                                <Col span={8} className='p-2'>
                                    <Item
                                        label="Expense Description"
                                        name="description"
                                        rules={[
                                            { required: true, message: 'Please enter your Description!' },
                                            { validator: validateSpaces }
                                        ]}
                                    >
                                        <Input disabled={paymentStatus} />
                                    </Item>
                                </Col>
                            </Row>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={8} className='p-2'>
                                    <Item
                                        label="Usage"
                                        name="main_usage"
                                    >
                                        <Input disabled={paymentStatus} />
                                    </Item>
                                </Col>
                                <Col span={8} className='p-2'>
                                    <Item
                                        label="Sub Usage"
                                        name="sub_usage"
                                    >
                                        <Input disabled={paymentStatus} />
                                    </Item>
                                </Col>
                                <Col span={8} className='p-2'>
                                    <Item
                                        label="Date Covered"
                                        name="date_covered"
                                        // className="mt-2"
                                    >
                                        <DatePicker disabled={paymentStatus} style={{ width: '100%' }} />
                                    </Item>
                                </Col>
                            </Row>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={8} className='p-2'>
                                    <Item
                                        label="Type"
                                        name="type"
                                        rules={[
                                            { required: true, message: 'Please enter your Type!' },
                                        ]}
                                    >
                                        <Select 
                                            placeholder="Select a Type"
                                            disabled={paymentStatus}
                                            showSearch
                                            onChange={handleType}
                                        >
                                            {type_select.map((option, index) => (
                                                <Option key={index} value={option.value}>{option.name}</Option>
                                            ))}
                                        </Select>
                                    </Item>
                                </Col>
                                {
                                    type === "tenant" && (
                                        <Col span={8} className='p-2'>
                                            <Item
                                                label="Tenant"
                                                name="tenant_id"
                                                rules={
                                                    type === "tenant"
                                                    ? [{ required: true, message: 'Please select a Tenant' }]
                                                    : []
                                                }            
                                            >
                                                <Select 
                                                    placeholder="Select a Tenant"
                                                    showSearch
                                                    disabled={paymentStatus}
                                                    onChange={(e) => handleUnits(e, "tenant")}
                                                    filterOption={(input, option) =>
                                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                                    }
                                                >
                                                    {tenantData.map((option, index) => (
                                                    <Option key={index} value={option.id}>{option.concatenated_tenant}</Option>
                                                    ))}
                                                </Select>
                                            </Item>
                                        </Col>
                                    )
                                }
                                {
                                    type === "owner" && (
                                        <>
                                            <Col span={8} className='p-2'>
                                                <Item
                                                    label="Owner"
                                                    name="owner_id"
                                                    rules={
                                                        type === "owner"
                                                        ? [{ required: true, message: 'Please select a Owner' }]
                                                        : []
                                                    }      
                                                >
                                                    <Select 
                                                        placeholder="Select a Owner"
                                                        showSearch
                                                        disabled={paymentStatus}
                                                        onChange={(e) => handleUnits(e, "owner")}
                                                        filterOption={(input, option) =>
                                                            option?.children?.toLowerCase().includes(input.toLowerCase())
                                                        }
                                                    >
                                                        {ownerData.map((option, index) => (
                                                            <Option key={index} value={option.id}>{option.name}</Option>
                                                        ))}
                                                    </Select>
                                                </Item>
                                            </Col>
                                            {
                                                form === 'unit' && (
                                                    <Col span={8} className='p-2'>
                                                        <Item
                                                            label="Rental Unit"
                                                            name="rental_unit_id"
                                                            rules={
                                                                type === "owner"
                                                                ? [{ required: true, message: 'Please select a Rental Unit' }]
                                                                : []
                                                            }      
                                                        >
                                                            <Select 
                                                                placeholder="Select a Rental Unit"
                                                                showSearch
                                                                disabled={paymentStatus}
                                                                filterOption={(input, option) =>
                                                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                                                }
                                                            >
                                                            {rentalUnitData.map((option, index) => (
                                                                <Option key={index} value={option.id}>{option.name}</Option>
                                                            ))}
                                                            </Select>
                                                        </Item>
                                                    </Col>
                                                )
                                            }
                                        </>
                                    )
                                }
                                {
                                    form === 'parking' && (
                                        <Col span={8} className='p-2'>
                                            <Item
                                                label="Parking Unit"
                                                name="parking_unit_id"
                                            >
                                            <Select 
                                                placeholder="Select a Parking Unit"
                                                showSearch
                                                disabled={paymentStatus}
                                                filterOption={(input, option) =>
                                                option?.children?.toLowerCase().includes(input.toLowerCase())
                                                }
                                            >
                                                {parkingUnitData.map((option, index) => (
                                                    <Option key={index} value={option.id}>{option.name}</Option>
                                                ))}
                                            </Select>
                                            </Item>
                                        </Col>
                                    )
                                }
                            </Row>
                            <Row>
                                <Col span={8} className='p-2'>
                                    <Item
                                        label="Remarks"
                                        name="remarks"
                                    >
                                        <Input disabled={paymentStatus}/>
                                    </Item>
                                </Col>
                            </Row>
                            <Divider className='divider-text'>List of Purchased Items</Divider>
                            {
                                validateExpenseArrayObjects(dataSource) && (
                                    <Row>
                                        <Col span={24} className='p-3 logout-icon'>
                                            Required*
                                        </Col>
                                    </Row>
                                )
                            }
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={24} className='p-2'>
                                    <Table
                                        dataSource={dataSource}
                                        columns={columns}
                                        pagination={false}
                                        bordered
                                    />
                                    <Button disabled={paymentStatus} type="primary" className='mt-4' onClick={handleAddRow}>
                                        Add Row
                                    </Button>
                                </Col>
                            </Row>
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={12}>
                                
                                </Col>
                                <Col span={12} className='p-3 amount-total' align='right'>
                                    Total: {formatAmount(grandTotal)}
                                </Col>
                            </Row>
                            {
                                label !== 'add' && (
                                    <Row className='my-5'>
                                        <Col span={24}>
                                            <Table 
                                            columns={columns2} 
                                            dataSource={newAttachment} 
                                            pagination={false}
                                            loading={{
                                                indicator: customSpinner,
                                                spinning: isLoading,
                                            }}
                                            />
                                        </Col>
                                    </Row>
                                )
                            }
                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                <Col span={24} className='p-2'>
                                    <Form form={addExpenseForm} layout="vertical">
                                        <Item 
                                            label="Attachment"
                                            name="attachments" 
                                            // valuePropName="fileList" 
                                            getValueFromEvent={normFile} 
                                            noStyle
                                        >
                                            <Upload.Dragger 
                                                multiple
                                                name="files" 
                                                disabled={paymentStatus}
                                                // action="/upload.do"
                                                fileList={attachmentsData}               
                                                beforeUpload={() => false}
                                                onRemove={handleDeleteAttachment}
                                            >
                                                <p className="ant-upload-drag-icon">
                                                    <InboxOutlined />
                                                </p>
                                                <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                                <p className="ant-upload-hint">Support for a single or bulk upload.</p>
                                            </Upload.Dragger>
                                        </Item>
                                    </Form>
                                </Col>
                            </Row>
                        
                            {
                                (type === "internal") && (
                                    <>
                                        <Divider className='divider-text'>Payment</Divider>
                                        <Row gutter={[16, 16]} className='responsive-inline responsive-width mt-2'>
                                            <Col span={24} className='p-2'>
                                                <Radio.Group disabled={paymentStatus} options={options} onChange={onMethodChange} value={paymentMethod} optionType="button" />
                                            </Col>
                                        </Row>
            
                                        <Form form={addExpenseForm} layout="vertical">
                                            <Row gutter={[16, 16]} className='responsive-inline responsive-width mt-2'>
                                                <Col span={8} className='p-2'>
                                                    <Item
                                                        label="Amount"
                                                        name="paid_amount"
                                                        className='p-0 m-0'
                                                        rules={
                                                            type === "internal"
                                                            ? [
                                                                { required: true, message: 'Please enter your Amount!' }
                                                                ]
                                                            : []
                                                        }
                                                    >
                                                        <InputNumber
                                                            style={{width:'100%'}}
                                                            disabled
                                                            min={0}
                                                            max={grandTotal}
                                                        />
                                                    </Item>
                                                </Col>
                                                <Col span={8} className='p-2'>
                                                    <Item
                                                        label="Payment Date"
                                                        name="payment_date"
                                                        className='p-0 m-0'
                                                        rules={
                                                            type === "internal"
                                                            ? [{ required: true, message: 'Please enter your Payment Date!' }]
                                                            : []
                                                        }
                                                    >
                                                        <DatePicker disabled={paymentStatus} style={{width:'100%'}}/>
                                                    </Item>
                                                </Col>
                                                <Col span={8} className='p-2'>
                                                    <Item
                                                        label="Remarks"
                                                        name="payment_remarks"
                                                        className='p-0 m-0'
                                                    >
                                                        <TextArea disabled={paymentStatus}/>
                                                    </Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={[16, 16]} className='responsive-inline responsive-width'>
                                            {
                                                paymentMethod === "check" && (
                                                    <>
                                                        <Col span={8} className='p-2'>
                                                        <Item
                                                            label="Bank Name"
                                                            name="bank"
                                                            className='p-0 m-0'
                                                            rules={
                                                                type === "internal"
                                                                ? [
                                                                    { required: true, message: 'Please enter your Bank Name!' },
                                                                    { validator: validateSpaces }
                                                                    ]
                                                                : []
                                                            }
                                                        >
                                                            <Input disabled={paymentStatus}/>
                                                        </Item>
                                                        </Col>
                                                        <Col span={8} className='p-2'>
                                                            <Item
                                                                label="Check Date"
                                                                name="check_date"
                                                                className='p-0 m-0'
                                                                rules={
                                                                    type === "internal"
                                                                    ? [{ required: true, message: 'Please enter your Check Date!' }]
                                                                    : []
                                                                }
                                                            >
                                                                <DatePicker disabled={paymentStatus} style={{width:'100%'}}/>
                                                            </Item>
                                                        </Col>
                                                        <Col span={8} className='p-2'>
                                                            <Item
                                                                label="Check Number"
                                                                name="check_no"
                                                                className='p-0 m-0'
                                                                rules={
                                                                    type === "internal"
                                                                    ? [
                                                                        { required: true, message: 'Please enter your Check Number!' },
                                                                        { validator: validateSpaces }
                                                                        ]
                                                                    : []
                                                                } 
                                                            >
                                                                <Input disabled={paymentStatus}/>
                                                            </Item>
                                                        </Col>
                                                    </>
                                                )
                                            }
                                            {
                                                paymentMethod === "others" && (
                                                    <>
                                                        <Col span={8} className='p-2'>
                                                        <Item
                                                            label="Type"
                                                            name="other_type"
                                                            className='p-0 m-0'
                                                            rules={
                                                                type === "internal"
                                                                ? [
                                                                    { required: true, message: 'Please enter your Type!' },
                                                                    { validator: validateSpaces }
                                                                    ]
                                                                : []
                                                            } 
                                                        >
                                                            <Input/>
                                                        </Item>
                                                        </Col>
                                                        <Col span={8} className='p-2'>
                                                        <Item
                                                            label="Reference Number"
                                                            name="reference_no"
                                                            className='p-0 m-0'
                                                            rules={
                                                                type === "internal"
                                                                ? [
                                                                    { required: true, message: 'Please enter your Reference Number!' },
                                                                    { validator: validateSpaces }
                                                                    ]
                                                                : []
                                                            }  
                                                        >
                                                            <Input/>                                  
                                                        </Item>
                                                        </Col>
                                                    </>
                                                )
                                            }
                                            </Row>
                                        </Form>
                                    </>
                                )
                            }
    
                            <Row className='btn-footer'>
                                <Space className='p-2'>
                                    <Button
                                        onClick={() => navigate(expense_form[form].path)}
                                        className='btn-header'
                                    >
                                        Close
                                    </Button>
                                
                                    {
                                        !paymentStatus && (
                                            <Button
                                                onClick={handleSaveExpense}
                                                type='primary'
                                                loading={loading}
                                                className='btn-header'
                                                disabled={
                                                    label === "add"
                                                      ? validateExpenseArrayObjects(dataSource) || isDisabled
                                                      : validateExpenseArrayObjects(dataSource)
                                                }
                                                  
                                            >
                                                {label === 'add' ? 'Submit' : 'Save'}
                                            </Button>
                                        )
                                    }
                                </Space>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </Layout>
        </Layout>
    )
}

export default AddEditExpense
  